import BilhetagemService from './BilhetagemService'
import { SERVICE_URL } from './ServiceURL'

class PropostaService {
  constructor (resource) {
    this.store = resource.$store
    this.http = resource.$http
    this.bilhetagemService = new BilhetagemService(resource)

    this.baseURL = `${SERVICE_URL}v1/arautos/pesquisa/proposta`
  }

  getReportSalesman () {
    return new Promise((resolve, reject) => {
      this.http.get(`${this.baseURL}/reports`, {
        headers: {
          'x-access-token': this.store.state.user.token || ''
        }
      })
        .then(response => response.json())
        .then(result => {
          resolve(result)
        })
        .catch(err => {
          reject(err.message || err)
        })
    })
  }

  save (proposta) {
    return new Promise((resolve, reject) => {
      this.http.post(this.baseURL, proposta, {
        headers: {
          'x-access-token': this.store.state.user.token || ''
        }
      })
        .then(response => response.json())
        .then(result => {
          resolve(result)
        })
        .catch(err => {
          reject(err.message || err)
        })
    })
  }
}

export default PropostaService



// WEBPACK FOOTER //
// ./src/service/PropostaService.js